/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './post-op-surgeon-notes.reducer';

export const PostOPSurgeonNotes = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const postOPSurgeonNotesList = useAppSelector(state => state.postOPSurgeonNotes.entities);
  const loading = useAppSelector(state => state.postOPSurgeonNotes.loading);
  const totalItems = useAppSelector(state => state.postOPSurgeonNotes.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="post-op-surgeon-notes-heading" data-cy="PostOPSurgeonNotesHeading">
        <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.home.title">Post OP Surgeon Notes</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/post-op-surgeon-notes/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.home.createLabel">Create new Post OP Surgeon Notes</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.postOPSurgeonNotes.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {postOPSurgeonNotesList && postOPSurgeonNotesList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('preOpDiagnosis')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.preOpDiagnosis">Pre Op Diagnosis</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preOpDiagnosis')} />
                </th>
                <th className="hand" onClick={sort('postOpDiagnosis')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.postOpDiagnosis">Post Op Diagnosis</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('postOpDiagnosis')} />
                </th>
                <th className="hand" onClick={sort('diagnosisDiscrepancy')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.diagnosisDiscrepancy">Diagnosis Discrepancy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('diagnosisDiscrepancy')} />
                </th>
                <th className="hand" onClick={sort('discrepancyNotes')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.discrepancyNotes">Discrepancy Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discrepancyNotes')} />
                </th>
                <th className="hand" onClick={sort('incision')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.incision">Incision</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('incision')} />
                </th>
                <th className="hand" onClick={sort('findings')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.findings">Findings</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('findings')} />
                </th>
                <th className="hand" onClick={sort('procedure')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.procedure">Procedure</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedure')} />
                </th>
                <th className="hand" onClick={sort('complications')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.complications">Complications</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('complications')} />
                </th>
                <th className="hand" onClick={sort('complicationNotes')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.complicationNotes">Complication Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('complicationNotes')} />
                </th>
                <th className="hand" onClick={sort('closure')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.closure">Closure</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('closure')} />
                </th>
                <th className="hand" onClick={sort('recovery')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.recovery">Recovery</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recovery')} />
                </th>
                <th className="hand" onClick={sort('specciman')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.specciman">Specciman</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('specciman')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.anaesthesiologist">Anaesthesiologist</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.surgeon">Surgeon</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.scrubNurse">Scrub Nurse</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {postOPSurgeonNotesList.map((postOPSurgeonNotes, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/post-op-surgeon-notes/${postOPSurgeonNotes.id}`} color="link" size="sm">
                      {postOPSurgeonNotes.id}
                    </Button>
                  </td>
                  <td>{postOPSurgeonNotes.preOpDiagnosis}</td>
                  <td>{postOPSurgeonNotes.postOpDiagnosis}</td>
                  <td>{postOPSurgeonNotes.diagnosisDiscrepancy}</td>
                  <td>{postOPSurgeonNotes.discrepancyNotes}</td>
                  <td>{postOPSurgeonNotes.incision}</td>
                  <td>{postOPSurgeonNotes.findings}</td>
                  <td>{postOPSurgeonNotes.procedure}</td>
                  <td>{postOPSurgeonNotes.complications ? 'true' : 'false'}</td>
                  <td>{postOPSurgeonNotes.complicationNotes}</td>
                  <td>{postOPSurgeonNotes.closure}</td>
                  <td>{postOPSurgeonNotes.recovery}</td>
                  <td>{postOPSurgeonNotes.specciman}</td>
                  <td>{postOPSurgeonNotes.active ? 'true' : 'false'}</td>
                  <td>{postOPSurgeonNotes.cursor}</td>
                  <td>{postOPSurgeonNotes.lastupdated}</td>
                  <td>{postOPSurgeonNotes.microSec}</td>
                  <td>{postOPSurgeonNotes.timestampentry}</td>
                  <td>
                    {postOPSurgeonNotes.surgery ? (
                      <Link to={`/patient-procedure/${postOPSurgeonNotes.surgery.id}`}>{postOPSurgeonNotes.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPSurgeonNotes.anaesthesiologist ? (
                      <Link to={`/doctor/${postOPSurgeonNotes.anaesthesiologist.id}`}>{postOPSurgeonNotes.anaesthesiologist.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPSurgeonNotes.surgeon ? (
                      <Link to={`/doctor/${postOPSurgeonNotes.surgeon.id}`}>{postOPSurgeonNotes.surgeon.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPSurgeonNotes.scrubNurse ? (
                      <Link to={`/nurse/${postOPSurgeonNotes.scrubNurse.id}`}>{postOPSurgeonNotes.scrubNurse.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/post-op-surgeon-notes/${postOPSurgeonNotes.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/post-op-surgeon-notes/${postOPSurgeonNotes.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/post-op-surgeon-notes/${postOPSurgeonNotes.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.home.notFound">No Post OP Surgeon Notes found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={postOPSurgeonNotesList && postOPSurgeonNotesList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PostOPSurgeonNotes;
